// @flow
import {
  clearState,
  setCompletePage,
  setPacket,
} from 'pages/Slices/packetSlice'
import { useLoadPacket } from 'queries/packets/useLoadPackets'
import * as React from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

type Props = {
  children: React.Node,
}

function PacketWrapper({ children }: Props): React.Node {
  const dispatch = useDispatch()

  const urlParams = useParams()
  const { data: packetData } = useLoadPacket(urlParams.packetId || '', {
    enabled: Boolean(urlParams.packetId),
  })

  React.useEffect(() => {
    const isNew = !Boolean(urlParams.packetId)
    if (isNew) {
      dispatch(clearState())
    } else {
      dispatch(setPacket(packetData))
      dispatch(
        setCompletePage({
          redirectUrl: packetData?.redirect_url,
          customCompletePage: packetData?.custom_complete_page,
          hasRedirectRules: packetData?.has_redirect_rules,
        })
      )
    }
  }, [dispatch, packetData, urlParams.packetId])

  return <>{children}</>
}

export default PacketWrapper
